import { useState, useEffect, useRef } from 'react';
import './PlayTabs.css';
import { Modal } from 'antd';
import { message, Form, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Pagination } from 'antd';
import {
    create_play_query_actionHandler,
    create_play_query_options_actionHandler,
    create_play_query_folders_actionHandler,
    create_play_query_supporting_folders_actionHandler,
    create_play_query_library_actionHandler,
    create_play_query_stop_loader,
    create_play_query_supporting_folders_success,
} from '../../Redux/Actions/user/CreatePlayQueryConvo';
import { create_play_chat_actionHandler } from '../../Redux/Actions/user/CreatePlayChatConvo';
import { create_play_view_history_actionHandler } from '../../Redux/Actions/user/CreatePlayHistory';
import { useDispatch, useSelector } from 'react-redux';
import { id } from 'date-fns/locale';
import { createGlobalStyle } from 'styled-components';
import { useInsertionEffect } from 'react';
import parse from 'html-react-parser';
import generatePDF from 'react-to-pdf';
import TypeWriter from './TypeWriter';
import { BASEURL } from '../../config';
import { LuCopyCheck } from 'react-icons/lu';
import { TiThumbsDown } from 'react-icons/ti';
import { PlayChat_Conversation_downvote_ActionHandler } from '../../Redux/Actions/user/PlayChatConversationDownVote';
import { HiMiniHandThumbDown } from 'react-icons/hi2';

function Query() {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const generatePDFIfChatNotEmpty = () => {
        if (!isChatEmpty) {
            generatePDF(targetRef, { filename: 'page.pdf' });
        } else {
            message.warning('No data/text available to generate PDF.');
        }
    };
    const items = [
        {
            label: (
                <p className='m-0' onClick={generatePDFIfChatNotEmpty}>
                    <svg
                        className='left'
                        xmlns='http://www.w3.org/2000/svg'
                        width='14'
                        height='16'
                        viewBox='0 0 14 16'
                        fill='none'>
                        <path
                            d='M0.507 1.60024V1.6C0.507 0.927895 0.969773 0.5 1.4 0.5H12.6C13.0332 0.5 13.5 0.93134 13.5 1.6V11.2C13.5 11.8687 13.0332 12.3 12.6 12.3H7.7H2.8H2.57312L2.42371 12.4707L0.500647 14.6685L0.507 1.60024Z'
                            stroke='black'
                        />
                    </svg>
                    <span> Download PDF</span>{' '}
                </p>
            ),
        },
        {
            type: 'divider',
        },
    ];
    const targetRef = useRef();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [open, setOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const handleButtonClick = () => {
        const idFold = documentList.map((doc) => doc.id);
        setSelectedCheckboxIds(idFold);
        setDisableSelect(idFold);
        setSidebarOpen(!isSidebarOpen);
    };
    const [error, setError] = useState(null);
    const [sessionID, setSessionID] = useState(null);
    const [ChatMessageQuery, setChatMessageQuery] = useState('');
    const [messageQuery, setMessageQuery] = useState([]);
    const [typing, setTyping] = useState(false);
    const [selectedWorkspace, setSelectedWorkspace] = useState('');
    const [selectedFolder, setSelectedFolder] = useState('');
    const [selectedFolderName, setSelectedFolderName] = useState('');
    const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
    const [currentId, setCurrentId] = useState(null);
    const [sessionHistoryId, setSessionHistoryId] = useState('');
    const [chatTittle, setChatTittle] = useState('');
    const [documentList, setDocumentList] = useState([]);
    const [showError, setShowError] = useState(false);
    const [selectedID, setSelectedID] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
    const [disableSelect, setDisableSelect] = useState([]);
    const isChatEmpty = messageQuery.length === 0;
    const [ChatMessage, setChatMessage] = useState('');
    const [tittle, setTittle] = useState('');
    const [streamResponse, setStreamResponse] = useState(null);
    const [isStreaming, setIsStreaming] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [showThumbdown, setShowdumbDown] = useState({});
    const resetSideBar = () => {
        setSidebarOpen(false);
        setSelectedFolder('');
        setSelectedFolderName('');
        setSelectedWorkspace('')
        dispatch(create_play_query_supporting_folders_success(''))
    }
    const handleCloseSidebar = () => resetSideBar();

    const handleStreamTypingCompleted = () => {
        setMessageQuery([
            ...messageQuery,
            { message: streamResponse, type: 'RESPONSE' },
        ]);
        setStreamResponse(null);
        setIsStreaming(false);
        setIsTyping(false);
    };
    const handleImgClick = () => {
        setChatTittle((prevValue) =>
            prevValue === 'Output Name' ? '' : prevValue
        );
        setIsEditable(!isEditable);
    };
    const getHistoryData =
        useSelector(
            (state) =>
                state.create_play_history_data?.create_play_history_data?.data
        ) || [];

    const isChatDOcument = useSelector(
        (state) => state.chatDocument.isChatDocument
    );
    const playchatProfile = useSelector(
        (state) =>
            state.SettingsUserProfileData?.user_profile_data?.profile_picture
    );

    const handleInputChange = (e) => {
        setChatTittle(e.target.value);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setIsEditable(false);
        }
    };

    const handleInputSave = () => {
        setChatTittle(chatTittle);
    };

    const handleInputKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (e.target.placeholder === 'Output Name') {
                e.preventDefault();
                handleInputSave();
                setIsEditable(false);
            }
        }
    };

    const handleInputBlur = () => {
        handleInputSave();
        setIsEditable(false);
    };
    const handleMouseLeave = () => {
        handleInputSave();
        setIsEditable(false);
    };

    const playChatStateQuery = useSelector(
        (state) => state.create_play_query_data
    );

    const playChatSessionId = useSelector(
        (state) =>
            state.create_play_query_data?.create_play_query_data?.data?.session
                ?.id
    );
    const [isButtonDisabled, setIsButtonDisabled] = useState(
        ChatMessageQuery.trim() === '' && typing
    );

    useEffect(() => {
        setIsButtonDisabled(ChatMessageQuery.trim() === '' && typing);
    }, [ChatMessageQuery, typing]);

    const sessionIdDelete = useSelector(
        (state) =>
            state.create_play_query_library_data?.create_play_query_library_data
                ?.data?.session?.id
    );
    const options = useSelector(
        (state) =>
            state.create_play_query_options_data?.create_play_query_options_data
                ?.data
    );
    const folders = useSelector(
        (state) =>
            state.create_play_query_folders_data?.create_play_query_folders_data
                ?.data
    );

    const libraryData = useSelector(
        (state) =>
            state.create_play_query_library_data?.create_play_query_library_data
                ?.data
    );
    const supportingFolders =
        useSelector(
            (state) =>
                state.create_play_query_supporting_folders_data
                    ?.create_play_query_supporting_folders_data?.data
        ) || [];
    const { data, total, per_page, current_page } = supportingFolders;

    const onFinish = (values) => {
        const conversationData = {
            message: ChatMessage,
            session_id: sessionID,
            supporting_document_ids:
                documentList?.length > 0
                    ? documentList.map((doc) => doc.id)
                    : [],
            title: chatTittle,
        };
        dispatch(create_play_chat_actionHandler(conversationData));
        form.resetFields();
        setChatTittle(values.name);
        setTittle(values.name);
        setIsModalVisible(false);
    };

    useEffect(() => {
        if (playChatStateQuery.create_play_query_data?.data) {
            if (messageQuery.length > 0) {
                setSessionID(
                    playChatStateQuery.create_play_query_data.data.session?.id
                );
                setShowError(playChatStateQuery?.error);
                if (playChatStateQuery.create_play_query_data.data?.response) {
                    setMessageQuery([
                        ...messageQuery,
                        playChatStateQuery.create_play_query_data.data,
                    ]);
                }
            }
        }
        if (
            playChatStateQuery?.getStreamingData &&
            playChatStateQuery.create_play_query_data?.data?.session?.id
        ) {
            (async () => {
                await fetchData(
                    playChatStateQuery.create_play_query_data?.data?.session?.id
                );
            })();
        }
    }, [playChatStateQuery]);

    const fetchData = async (sessionId) => {
        setStreamResponse(null);
        const token = localStorage.getItem('token');
        const headers = new Headers({
            Authorization: 'Bearer ' + token,
        });

        try {
            const response = await fetch(
                BASEURL + 'play-chat/' + sessionId + '/stream-chat',
                {
                    method: 'POST',
                    headers: headers,
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const reader = response.body.getReader();
            const textDecoder = new TextDecoder('utf-8'); // Adjust the encoding if necessary

            let receivedData = '';

            const readChunk = async () => {
                const { value, done } = await reader.read();
                setIsStreaming(true);
                setIsTyping(true);
                dispatch(create_play_query_stop_loader(false));
                if (done) {
                    setIsStreaming(false);
                    return;
                }

                const chunkString = textDecoder.decode(value);
                receivedData += chunkString;
                setStreamResponse(receivedData);
                // Continue reading the next chunk
                readChunk();
            };

            // Start reading chunks
            readChunk();
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    const HistoryContent = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data
    );

    // Store the sessionId if the chat is initiated first time
    useEffect(() => {
        // if (HistoryContent?.session?.id) {

        //   setSessionID(HistoryContent.session.id);
        // }
        if (HistoryContent?.documents) {
            setDocumentList([...HistoryContent?.documents]);
        }
    }, [HistoryContent]);

    useEffect(() => {
        if (libraryData?.session?.id) {
            setSessionID(libraryData.session.id);
        }
        if (libraryData?.documents) {
            setDocumentList([...libraryData?.documents]);
        }
    }, [libraryData]);

    useEffect(() => {
        dispatch(create_play_query_options_actionHandler());
    }, [dispatch]);

    const selectWorkspace = (e) => {
        setSelectedWorkspace(e.target.value);
        const [id, name] = e.target.value.split(': ');
        dispatch(create_play_query_folders_actionHandler(id, selectedFolder, page));
    };
    const [page, setPage] = useState(1);
    const selectFolder = (e) => {
        setSelectedFolder(e.target.value);
        const [id, name] = e.target.value.split(': ');
        setSelectedFolderName(name);
        dispatch(
            create_play_query_supporting_folders_actionHandler(
                id,
                selectedWorkspace,
                page
            )
        );
    };
    const updateData = () => {
        const temSelectedData = documentList.map((doc) => doc.id);
        const payload = {
            supporting_document_ids: [
                ...temSelectedData,
                ...selectedCheckboxIds,
            ],
            title: chatTittle,
            message: '',
            session_id: sessionID,
        };
        if (selectedCheckboxIds?.length) {
            dispatch(create_play_query_library_actionHandler(payload));
            message.success('Data updated successfully');
        }
        setSelectedCheckboxIds([]);
        resetSideBar();
    };

    // const handleCheckboxChange = (e, id) => {
    //     if (selectedCheckboxIds.includes(id)) {
    //         // Checkbox is already selected, remove it
    //         const updatedCheckBoxId = selectedCheckboxIds.filter(itemId => itemId !== id);
    //         setSelectedCheckboxIds(updatedCheckBoxId);
    //     } else {
    //         // Checkbox is not selected, add it
    //         const tempStoreDocID = [...selectedCheckboxIds, id];
    //         setSelectedCheckboxIds(tempStoreDocID);
    //     }
    // };
    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            const tempStoreDocID = [...selectedCheckboxIds, id];
            setSelectedCheckboxIds(tempStoreDocID);
        } else {
            const updatedCheckBoxId = selectedCheckboxIds.filter(
                (itemId) => itemId != id
            );
            setSelectedCheckboxIds(updatedCheckBoxId);
        }
    };

    const down_voteData = useSelector(
        (state) => state.PlayChat_Down_voteData?.down_vote_data?.data
    );

    const dataHistoryId = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data?.session?.id
    );
    useEffect(() => {
        if (dataHistoryId !== undefined) {
            const filteredHistoryData = getHistoryData.data.filter(
                (item) => item.id === dataHistoryId
            );
            if (filteredHistoryData.length > 0) {
                setChatTittle(filteredHistoryData[0].title);
                setTittle(filteredHistoryData[0].title);
            }
        }
    }, [getHistoryData.data, dataHistoryId]);
    const dataHistoryTitle = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data?.session?.title
    );
    const dataQuery = useSelector(
        (state) =>
            state.create_play_view_history_data?.create_play_view_history_data
                ?.data
    );

    useEffect(() => {
        if (dataQuery?.chat && isChatDOcument) {
            setMessageQuery([...dataQuery.chat]);
            setSessionID(dataHistoryId);
            setChatTittle(dataHistoryTitle);
        }
    }, [dataQuery]);

    const handleSendMessage = async () => {
        if (ChatMessageQuery.trim() === '') {
            message.error('Please enter a message!');
            return;
        }
        setMessageQuery([...messageQuery, { message: ChatMessageQuery }]);
        const conversationData = {
            message: ChatMessageQuery,
            session_id: sessionID,
            supporting_document_ids:
                documentList?.length > 0
                    ? documentList.map((doc) => doc.id)
                    : [],
            title: chatTittle,
        };

        try {
            setTyping(true);
            const apiResponse = dispatch(
                create_play_query_actionHandler(conversationData)
            );
        } catch (error) {
            setTyping(false);
        }
        setChatMessageQuery('');
    };
    const showModal = (idx) => {
        setOpen(true);
        setDeleteIndex(idx);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleCopyClick = () => {
        const chatScreenContent = targetRef.current.innerText;
        if (chatScreenContent.trim() === '') {
            message.error('No text/Data to copy');
            return;
        }

        navigator.clipboard
            .writeText(chatScreenContent)
            .then(() => {
                setIsCopied(true);
                message.success('Copied to clipboard');
            })
            .catch((error) => {
                console.error('Error copying chat screen:', error);
                message.error('Error copying chat screen');
            });
    };

    const handleRefreshQueryClick = () => {
        setMessageQuery([]);
        setSessionID('');
        setChatTittle('');
        setDocumentList([]);
    };

    const deleteFolder = (idx, session_id) => {
        const tempSelectedDocument = [...documentList];
        tempSelectedDocument.splice(idx, 1);
        setDocumentList([...tempSelectedDocument]);
        const payload = {
            supporting_document_ids: tempSelectedDocument.map((doc) => doc.id),
            title: chatTittle,
            message: '',
            session_id: sessionID,
        };
        dispatch(create_play_query_actionHandler(payload));
        message.success('Document removed');
    };

    const paginate = (newPage) => {
        dispatch(
            create_play_query_supporting_folders_actionHandler(
                selectedFolder,
                selectedWorkspace,
                newPage
            )
        );
    };

    useEffect(() => {
        setDocumentList([]);
    }, []);

    useEffect(() => {
        setSelectedID(documentList?.map((doc) => doc.id));
    }, [documentList]);

    const copyResponseData = (msg) => {
        if (msg) {
            navigator.clipboard
                .writeText(msg)
                .then(() => {
                    message.success('Copied to clipboard');
                })
                .catch((error) => {
                    message.error('Error copying ');
                });
        }
    };

    const callThumbDowApi = (id) => {
        if (id && sessionID)
            dispatch(
                PlayChat_Conversation_downvote_ActionHandler(sessionID, id)
            );
    };

    useEffect(() => {
        if (down_voteData) {
            setShowdumbDown(down_voteData);
        }
    }, [down_voteData]);

    useEffect(() => {
        if (showThumbdown?.id) {
            setMessageQuery((prevMessages) =>
                prevMessages?.map((message) =>
                    message?.id === showThumbdown?.id
                        ? { ...message, is_down_voted: true }
                        : message
                )
            );
        }
    }, [showThumbdown]);

    return (
        <div>
            <p className='play-first'>
                <button
                    className='data-library mb-5'
                    onClick={handleButtonClick}>
                    Select from Data Library
                </button>
            </p>

            {isSidebarOpen && (
                <div className='sidebar_query'>
                    <div className='flex justify-between items-center mb-5'>
                        <h3 className='mb-0 heading-sidebar'>
                            Select Data Library
                        </h3>
                        <button className='close-btn'>
                            <img
                                className='close-icon'
                                src='/images/close-icon.svg'
                                onClick={handleCloseSidebar}
                            />
                        </button>
                    </div>
                    <div className='mb-3 pb-2'>
                        <label className='sidebar-field-label'>
                            Select Workspace
                        </label>
                        <select
                            onChange={selectWorkspace}
                            className='sidebar-field form-control form-select'>
                            <option value='' disabled selected>
                                Select a Workspace
                            </option>
                            {options
                                ?.filter((option) => !option.is_locked)
                                .map((option, index) => (
                                    <option key={index} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className='mb-4 pb-2'>
                        <label className='sidebar-field-label'>
                            Select Folder
                        </label>
                        <select
                            value={selectedFolder}
                            onChange={selectFolder}
                            className='sidebar-field form-control form-select'>
                            <option value='' disabled selected>
                                Select a Folder
                            </option>
                            {folders?.length > 0 &&
                                folders.map((folder, index) => (
                                    <option key={index} value={folder.id}>
                                        {folder.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className='mb-4 pb-2'>
                        <label className='sidebar-field-label'>
                            Select the documents you want to chat with
                        </label>
                        <div className='table-responsive reference_table_responsive'>
                            <table className='table table-striped reference_table table-borderless'>
                                <thead>
                                    <th>Reference Data</th>
                                    <th>Folder Name</th>
                                </thead>
                                <tbody>
                                    {data?.length > 0 &&
                                        data.map((folder, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className='form-check mb-0'>
                                                        <input
                                                            className={`form-check-input shadow-none ${
                                                                disableSelect?.includes(
                                                                    folder.id
                                                                )
                                                                    ? 'disabled-checkbox'
                                                                    : ''
                                                            }`}
                                                            type='checkbox'
                                                            checked={selectedCheckboxIds.includes(
                                                                folder.id
                                                            )}
                                                            disabled={disableSelect?.includes(
                                                                folder.id
                                                            )}
                                                            onChange={(e) =>
                                                                handleCheckboxChange(
                                                                    e,
                                                                    folder.id
                                                                )
                                                            }
                                                            id={`reference${
                                                                index + 1
                                                            }`}
                                                        />
                                                        <label
                                                            className='form-check-label'
                                                            htmlFor={`reference${
                                                                index + 1
                                                            }`}>
                                                            {folder.name}
                                                        </label>
                                                    </div>
                                                </td>
                                                <td>{folder?.folder?.name}</td>{' '}
                                            </tr>
                                        ))}
                                </tbody>
                            </table>

                            <div className='pagi-div'>
                                {total > 1 && (
                                    <Pagination
                                        defaultCurrent={1}
                                        current={current_page}
                                        total={total}
                                        pageSize={per_page}
                                        onChange={paginate}
                                    />
                                )}
                            </div>
                        </div>
                        <div className='buttonUpdate'>
                            <button onClick={updateData}>Update</button>
                        </div>
                    </div>
                </div>
            )}
            <h3 className='document-heading'>Your Documents</h3>
            <div className='chat-upper '>
                <div className='table-responsive query_table_responsive'>
                    <table className='table table-borderless query_table'>
                        <thead>
                            <th className='query-table-head query_table_responsive'>
                                Reference Data
                            </th>
                            <th className='query_table_responsive'>
                                Workspace
                            </th>
                            <th className='query_table_responsive'>Folder</th>
                            <th className='query_table_responsive'>Action</th>
                        </thead>
                        <tbody>
                            {documentList?.length > 0 &&
                                documentList.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td>{item.name}</td>
                                        <td>{item.workspace_name}</td>
                                        <td>{item.folder_name}</td>
                                        <td>
                                            <button
                                                className='delete-btn'
                                                onClick={() => {
                                                    deleteFolder(
                                                        idx,
                                                        sessionIdDelete
                                                    );
                                                }}>
                                                <img src='/images/trash_icon.svg' />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    <div className='pagi-div'>
                        {documentList && documentList.length > 0 && (
                            <Pagination />
                        )}
                    </div>
                </div>
                <div className='buttons'>
                    <div className='flex justify-content-end sub-btns '>
                        <div className='output-container'>
                            <input
                                type='text'
                                placeholder='Chat Title'
                                className='output-input'
                                onKeyUp={handleInputKeyUp}
                                onBlur={handleInputBlur}
                                onMouseLeave={handleMouseLeave}
                                value={tittle}
                                disabled
                            />
                            <img
                                src='/images/output.svg'
                                className='output-img-query'
                                alt=''
                                onClick={() => setIsModalVisible(true)}
                            />
                        </div>
                        <button className='msg-btn'>
                            <img
                                src='/images/copy.svg'
                                className='output-img'
                                alt=''
                                onClick={handleCopyClick}
                            />
                        </button>
                        <button
                            className='msg-btn'
                            onClick={handleRefreshQueryClick}>
                            <img
                                src='/images/refresh.svg'
                                className='output-img'
                                alt=''
                            />
                        </button>
                        <div className='downlod-div'>
                            <img
                                src='/images/icon-dwnld.svg'
                                className='new-img me-1'
                                alt=''
                            />

                            <Dropdown
                                menu={{
                                    items,
                                }}
                                trigger={['click']}>
                                <p
                                    className='dropdown-custom download-b'
                                    onClick={(e) => e.preventDefault()}>
                                    <Space>
                                        Download <DownOutlined />
                                    </Space>
                                </p>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className='message-section' ref={targetRef}>
                    <div className='chat-screen'>
                        {messageQuery.length > 0 &&
                            messageQuery?.map((msg, index) => (
                                <div
                                    key={index}
                                    className={`${msg.sender}-msg ${
                                        index == messageQuery.length - 1
                                            ? 'last-response'
                                            : 'svooo'
                                    }`}>
                                    <div className='input-text'>
                                        <span className='qa-profile'>
                                            {msg.session ||
                                            msg.type === 'RESPONSE' ? (
                                                <img
                                                    className='qa-pic'
                                                    src='/images/QA-icon.png'
                                                    alt='QA'
                                                />
                                            ) : (
                                                <img
                                                    className='user-pic'
                                                    src={playchatProfile}
                                                    alt='User'
                                                />
                                            )}
                                        </span>
                                        <span
                                            className='message-text'
                                            style={{ whiteSpace: 'pre-wrap' }}>
                                            {!msg.session
                                                ? parse(msg.message)
                                                : parse(msg.response)}
                                        </span>
                                    </div>
                                    {msg?.type === 'RESPONSE' && (
                                        <p className='copy-with-thmubdown'>
                                            <LuCopyCheck
                                                onClick={() =>
                                                    copyResponseData(
                                                        msg?.message
                                                    )
                                                }
                                            />
                                            {!msg?.is_down_voted ? (
                                                <TiThumbsDown
                                                    onClick={() =>
                                                        callThumbDowApi(msg?.id)
                                                    }
                                                />
                                            ) : (
                                                <HiMiniHandThumbDown />
                                            )}
                                        </p>
                                    )}
                                </div>
                            ))}
                        <div className='qa-msg align-items-center'>
                            {isTyping && streamResponse && (
                                <div>
                                    <div className='input-text'>
                                        <span className='qa-profile'>
                                            <img
                                                className='qa-pic'
                                                src='/images/QA-icon.png'
                                                alt='QA'
                                            />
                                        </span>
                                        <TypeWriter
                                            className='message-text typewriter'
                                            content={streamResponse}
                                            isStreaming={isStreaming}
                                            handleStreamTypingCompleted={
                                                handleStreamTypingCompleted
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            {playChatStateQuery?.loader && (
                                <div className='typing-indicator'>
                                    {' '}
                                    <span>
                                        {' '}
                                        <img
                                            className='qa-pic'
                                            src='/images/QA-icon.png'
                                            // src='/images/QA_Logo_Annimation.gif'
                                            alt='QA'
                                        />
                                    </span>{' '}
                                    <span className='typewriter'>
                                        is typing....
                                    </span>
                                </div>
                            )}
                            {showError && (
                                <div className='typing-indicator'>
                                    Error....
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='message-field-wrapper'>
                        <textarea
                            className='message-field'
                            placeholder='Ask a Question and press enter to submit.'
                            value={ChatMessageQuery}
                            onChange={(e) =>
                                setChatMessageQuery(e.target.value)
                            }
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage();
                                }
                            }}
                            disabled={playChatStateQuery.loader}
                        />
                        <button
                            id='send-button'
                            className='message-send-btn'
                            onClick={handleSendMessage}
                            disabled={isButtonDisabled}>
                            <img src='/images/send-message.svg' />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                title='Update Chat Title'
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                className='user-management-modal'>
                <Form
                    form={form}
                    onFinish={onFinish}
                    initialValues={{ name: chatTittle }}>
                    <Form.Item
                        label='Enter Chat Title'
                        name='name'
                        rules={[
                            {
                                required: true,
                                message: 'Please input the chat title!',
                            },
                        ]}>
                        <Input
                            value={chatTittle}
                            onChange={handleInputChange}
                        />
                    </Form.Item>
                    <Form.Item>
                        <button
                            type='submit'
                            className='model-btn-submit-management'>
                            Update
                        </button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}
export default Query;
